module.exports = __webpack_public_path__ + "static/media/SUBDRIVESOLARPAK.fdee953f.pdf";